import * as React from "react";
import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import usePermissions from "hooks/usePermissions";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import { useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useHistory from "routing/useHistory";
import { EvidenceList, EvidenceRow, IconButton, StyledLink } from "../styled.components";
function Searches({ investigation }) {
  const { t } = useTranslation("enterprise_security_investigations");
  const { isPermitted } = usePermissions();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteSearchId, setDeleteSearchId] = useState(null);
  const history = useHistory();
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted("investigations:edit"),
    [investigation.archived, isPermitted]
  );
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const removeSearch = async () => {
    await removeEvidence({ invId: investigation.id, payload: { searches: [deleteSearchId] } });
    setShowDeleteDialog(false);
    setDeleteSearchId(null);
  };
  const onDelete = (searchId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteSearchId(searchId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteSearchId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EvidenceList, null, investigation.searches.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "gray" } }, t("drawer_searches.empty")) : investigation.searches.map((search) => /* @__PURE__ */ React.createElement(EvidenceRow, { key: search.id, $fullWidth: true, $gap: "0" }, canManageEvidence && /* @__PURE__ */ React.createElement(IconButton, { $danger: true, "data-testid": `delete-${search.id}`, onClick: onDelete(search.id) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })), /* @__PURE__ */ React.createElement(StyledLink, { onClick: () => history.push(Routes.VIEWS.VIEWID(search.id)) }, search.title)))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: t("drawer_searches.delete_title"),
      onConfirm: removeSearch,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    t("drawer_searches.delete_confirm")
  ));
}
export default Searches;
